export default "__VITE_ASSET__a1b090fe__"